import { bool, object } from 'prop-types'

import { Box, Divider } from '@telus-uds/components-web'
import { ModuleTranslationProvider } from '../../../contexts/ModuleTranslation'
import { getParentItemWithNestedSubItems } from '../../../utils/mobility'
import MobilityAccessory from '../../organisms/MobilityAccessory/MobilityAccessory'
import FinancedDetailsFooter from './FinancedDetailsFooter'
import FinancedSubscriberBanner from './FinancedSubscriberBanner'
import translations from '../../organisms/MobilityAccessory/locales'

const FinancedAccessoryGroup = ({ accessoryGroup, isPurchasedWithPhone, cart }) => {
  if (!accessoryGroup || !cart) return null
  // populating group with nested sub-items data to render each sub-item to `MobilityAccessory` component
  const groupWithItems = getParentItemWithNestedSubItems(accessoryGroup, cart)
  const groupItems = Object.values(groupWithItems.items)

  const financeDetails = accessoryGroup?.financeDetails[0]
  const mappedItems = groupItems.map((accessory, index) => {
    const accessoryItem = { ...accessory }
    // correct contract term will be only on the group level, replacing to item level to prevent big changes
    accessoryItem.contractTerm = { ...accessoryGroup.contractTerm }

    const isFirstAccessoryInGroup = index === 0

    return (
      <Box vertical={3} key={accessory.id}>
        <MobilityAccessory
          key={accessory.id}
          mobAccessory={accessoryItem}
          cart={cart}
          isPurchasedWithPhone={isPurchasedWithPhone}
          isFirstAccessoryInGroup={isFirstAccessoryInGroup}
          financedAccessoryGroup={accessoryGroup}
        />
      </Box>
    )
  })

  return (
    <ModuleTranslationProvider translations={translations} module="mobility-accessory">
      <FinancedSubscriberBanner
        accessoryGroup={accessoryGroup}
        isPurchasedWithPhone={isPurchasedWithPhone}
      />
      {isPurchasedWithPhone && (
        <Box top={3} bottom={3}>
          <Divider variant={{ decorative: true }} />
        </Box>
      )}
      {mappedItems}
      <FinancedDetailsFooter financeDetails={financeDetails} />
    </ModuleTranslationProvider>
  )
}

export default FinancedAccessoryGroup

FinancedAccessoryGroup.propTypes = {
  accessoryGroup: object,
  isPurchasedWithPhone: bool,
  cart: object.isRequired
}

FinancedAccessoryGroup.defaultProps = {
  accessoryGroup: undefined,
  isPurchasedWithPhone: false
}
